var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        viewBox: "0 0 2499.9999 2500.0001",
        width: _vm.size,
        height: _vm.size,
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        staticClass: "cls-2",
        staticStyle: { "stroke-width": "28.0616" },
        attrs: {
          d:
            "m 0.55537054,1245.8533 c 0,722.0253 554.77838946,1205.2466 1248.46182946,1205.2466 693.6835,0 1248.1812,-483.2213 1248.1812,-1205.2466 0,-349.64826 -125.4355,-663.37701 -316.8159,-858.12513 -584.2429,-593.50341 -1092.7197,-259.00882 -1218.15517,37.88325 -24.41356,58.36837 -10.94402,109.72107 65.10297,148.72667 l 1015.831,636.15731 a 64.261127,64.261127 0 0 1 0,112.2466 L 808.44966,1928.5924 a 64.261127,64.261127 0 0 1 -94.5677,-56.123 V 815.38754 c 0,-396.79148 45.45983,-542.15058 79.13382,-637.84061 25.536,-72.11854 -11.78593,-96.251611 -63.69993,-70.1542 C 640.92173,151.73007 0.55537054,572.6543 0.55537054,1245.8533 Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }